// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"ef94c162","711":"65421113","966":"0d1e5ffd"}[chunkId] + ".chunk.js";
};